import type { CompanionSocialMoment } from "@/lib/companion/people-loop";
import { CompanionSteezeButton } from "./CompanionSteezeButton";
import { BlockUserButton } from "@/app/_components/BlockUserButton";
import { ReportContentLink } from "@/app/_components/ReportContentLink";

export function CompanionSocialFeed({
  moments,
  unavailable,
}: {
  moments: CompanionSocialMoment[];
  unavailable: boolean;
}) {
  return (
    <section aria-labelledby="people-social-heading" className="rounded-md border border-border-light bg-white p-4 md:p-5">
      <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-teal">Private Social</p>
      <h2 id="people-social-heading" className="mt-1 font-serif text-[26px] leading-tight text-navy">Squad moments</h2>
      {unavailable ? (
        <p role="status" className="mt-3 rounded-sm border border-terracotta/35 bg-terracotta/10 px-3 py-2 text-[12px] text-navy">Social updates are unavailable. Roll call and meet-ups still work.</p>
      ) : moments.length > 0 ? (
        <ol className="mt-4 divide-y divide-border-light border-y border-border-light">
          {moments.map((moment) => (
            <li key={`${moment.squadId}-${moment.id}`} className="py-4">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="text-[13px] font-semibold text-navy">{moment.actorDisplayName} · {moment.squadName}</p>
                <time dateTime={moment.occurredAt} className="text-[11px] text-text-muted">{formatMomentTime(moment.occurredAt)}</time>
              </div>
              <p className="mt-2 text-[13px] leading-relaxed text-text-body">{moment.summary}</p>
              {moment.placeName ? <p className="mt-1 text-[11px] font-semibold text-teal">{moment.placeName}</p> : null}
              <CompanionSteezeButton
                squadId={moment.squadId}
                momentId={moment.id}
                initialCount={moment.steezeCount}
                initialActive={moment.viewerGaveSteeze}
              />
              <BlockUserButton moment={{ id: moment.id, squadId: moment.squadId }} displayName={moment.actorDisplayName} />
              <ReportContentLink context={{ kind: "squad-moment", id: moment.id, squadId: moment.squadId }} />
            </li>
          ))}
        </ol>
      ) : (
        <p className="mt-3 text-[13px] leading-relaxed text-text-muted">Quiet for now. Private moments appear after opted-in Squad activity.</p>
      )}
    </section>
  );
}

function formatMomentTime(value: string): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return "Recently";
  return new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit" }).format(date);
}
